import { UseQueryResult, keepPreviousData } from '@tanstack/react-query'
import { useMemo } from 'react'

import { Comment, CommentRootUuid, dummyComment, parseComment } from '../../models/Comment'
import * as api from '../api'
import { useApiQuery } from '../useApiQuery'
import { ReturnsComments } from '../useInvalidate'

export default function useComment({
  commentUuid,
  ...rootUuid
}: {
  commentUuid: string
} & CommentRootUuid) {
  const result: UseQueryResult<Comment> = useApiQuery({
    queryKey: [
      'comment',
      ReturnsComments,
      'learningItemUuid' in rootUuid ? rootUuid.learningItemUuid : rootUuid.groupUuid,
      commentUuid,
    ],
    placeholderData: keepPreviousData,
    queryFn: async () => {
      try {
        return parseComment(
          'groupUuid' in rootUuid
            ? await api.get(
                `group/${encodeURIComponent(rootUuid.groupUuid)}/comment/${encodeURIComponent(commentUuid)}`
              )
            : await api.get(
                `course/${encodeURIComponent(rootUuid.learningItemUuid)}/comment/${encodeURIComponent(commentUuid)}`
              )
        )
      } catch (err) {
        return dummyComment(commentUuid, err)
      }
    },
  })

  const comment = useMemo(() => result.data || dummyComment(commentUuid), [result.data, commentUuid])

  return {
    ...result,
    comment,
  }
}
